export var Languages;
(function (Languages) {
    Languages["sql"] = "sql";
    Languages["json"] = "json";
    Languages["powershell"] = "powershell";
})(Languages || (Languages = {}));
